import { RouterOutlet } from '@angular/router';
import { Component, OnInit, HostBinding, ChangeDetectionStrategy } from '@angular/core';
import { OverlayContainer } from '@angular/cdk/overlay';
import { InterceptorServices } from './_Common/_Services/http-interceptors';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet],
    templateUrl: './app.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    providers: [InterceptorServices]
})
export class AppComponent implements OnInit {
  title = 'moneytor-app';
  isDark: boolean = false;

  @HostBinding('class') componentCssClass: string | undefined;
  constructor(public overlayContainer: OverlayContainer) {}

  ngOnInit() {
    // const isDark: any = JSON.parse(localStorage.getItem('isDarkMode'));
    // this.onSetTheme({ checked: false });
  }

  // to set theme
  onSetTheme($event: any) {
    const { checked } = $event;
    const theme = checked ? 'dark' : 'light';
    this.overlayContainer.getContainerElement().classList.add(theme);
    this.componentCssClass = theme;
    this.isDark = !checked;
    localStorage.setItem('isDarkMode', JSON.stringify(checked));
  }
}
